// extracted by mini-css-extract-plugin
module.exports = {"item":"Bfnck1","checkIcon":"LClhr7"};